import React from 'react';

import Text from 'components/core/Text';

import { TGroupSummary } from 'types/story';

import { describePendingChanges, metaText, publishedAgo } from '../../GroupsList.helpers';
import {
  StyledChangeList,
  StyledSection,
  StyledSectionLabel,
  StyledSummary,
} from './PublishSummary.styles';

type TPublishSummaryProps = {
  group: TGroupSummary;
};

const PublishSummary = ({ group }: TPublishSummaryProps) => {
  const changes = describePendingChanges(group);
  const publishedLabel = publishedAgo(group.publishedAt);

  return (
    <StyledSummary>
      {group.liveMeta ? (
        <StyledSection>
          <StyledSectionLabel>Live now</StyledSectionLabel>
          <Text variant="body" color="textSecondary">
            {metaText(group.liveMeta)}
            {publishedLabel ? ` · published ${publishedLabel}` : ''}
          </Text>
        </StyledSection>
      ) : null}

      {changes.length ? (
        <StyledSection>
          <StyledSectionLabel>Publishing will change</StyledSectionLabel>
          <StyledChangeList>
            {changes.map((change) => (
              <li key={change}>{change}</li>
            ))}
          </StyledChangeList>
        </StyledSection>
      ) : null}

      <Text variant="body" color="textSecondary">
        {group.hasLive
          ? 'The draft is frozen as the new live version. It shows inside its schedule window — with no dates it shows immediately and never expires. A fresh draft opens for further edits.'
          : 'Freeze the current draft as the live version. It goes live inside its schedule window — with no dates it shows immediately and never expires. A fresh draft opens for further edits.'}
      </Text>
    </StyledSummary>
  );
};

export default PublishSummary;
